export type Point3D = [number, number, number];

export interface SagittalSpineMetrics {
  lower_perp_vector: [number, number, number];
  lower_point: [number, number, number];
  upper_perp_vector: [number, number, number];
  upper_point: [number, number, number];
  angle: number;
}

export interface LegAngles {
  ankle_flexion_angle: number;
  ankle_flexion_left: number;
  ankle_flexion_right: number;
  knee_bend_angle: number;
  knee_bend_left: number;
  knee_bend_right: number;
}

export interface SagittalDisplayDict {
  joint_locations: Point3D[];
  leg_angles: LegAngles;
  max_lower_sagittal: SagittalSpineMetrics;
  max_upper_sagittal: SagittalSpineMetrics;
  surface_spline_spine: {
    points: Point3D[];
  };
}

export interface SagittalMetrics {
  shoulder_rotation: number | null;
  sagittal_balance: number | null;
  sagittal_balance_plane: number | null;
  sagittal_msl_plane: number | null;
  max_upper_sagittal_angle: number | null;
  max_lower_sagittal_angle: number | null;
  hip_to_ear_angle: number | null;
  ankle_to_ear_angle: number | null;
  center_of_mass: Point3D | null;
  center_of_mass_above_knees: Point3D | null;
  center_of_mass_above_hips: Point3D | null;
  center_of_mass_above_shoulders: Point3D | null;
  sagittal_display_dict: SagittalDisplayDict | null;
}

export const jointLocationDict = {
  left_hip: 1,
  right_hip: 2,
  left_knee: 4,
  right_knee: 5,
  left_ankle: 7,
  right_ankle: 8,
  right_ear: 27,
  left_ear: 28,
} as const;
